import { useState } from 'react';
import { IconPlus } from '@tabler/icons-react';

interface ContentFaqProps {
  faqs: { q: string; a: string }[];
  title?: string;
  subtitle?: string;
}

/** FAQ accordion for content pages (same pattern as comparison FAQs). */
export function ContentFaq({
  faqs,
  title = 'Common questions',
  subtitle,
}: ContentFaqProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="mb-12 pt-10" style={{ borderTop: '1px solid var(--warm-border)' }}>
      <h2 className="font-display text-2xl md:text-[1.75rem] leading-tight mb-1" style={{ color: 'var(--warm-text)' }}>
        {title}
      </h2>
      {subtitle && <p className="text-xs mb-4" style={{ color: 'var(--warm-muted)' }}>{subtitle}</p>}
      <div className="mt-4">
        {faqs.map((item, i) => {
          const open = openIndex === i;
          return (
            <div key={i} style={{ borderBottom: '1px solid var(--warm-border)' }}>
              <button
                onClick={() => setOpenIndex(open ? null : i)}
                aria-expanded={open}
                className="flex w-full items-center justify-between gap-4 py-4 text-left"
              >
                <span className="text-[15px] font-medium" style={{ color: 'var(--warm-text)' }}>{item.q}</span>
                <IconPlus
                  size={18} stroke={1.5}
                  className="shrink-0 transition-transform duration-300"
                  style={{ color: 'var(--warm-muted)', transform: open ? 'rotate(45deg)' : 'none' }}
                />
              </button>
              {open && (
                <p className="pb-5 text-[15px] leading-relaxed" style={{ color: 'var(--warm-muted)' }}>{item.a}</p>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
